import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router.tsx';
import { applyStoredTheme } from '@verydia/ui';
import { AuthProvider } from './lib/auth/index.ts';
import { ConsoleContextProvider } from './lib/console-context.tsx';
import './styles/app.css';

// Before the first paint, and above the router: pages outside the console shell
// — sign-in, the OAuth callback, the loading curtain — must honour the
// operator's theme too, and the shell is not mounted for any of them.
applyStoredTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The SDK already retries 429s and 5xx with jittered backoff. A second
      // retry layer here would multiply the delay an operator waits before
      // being told something is wrong.
      retry: false,
      refetchOnWindowFocus: true,
      staleTime: 15_000,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Console root element is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ConsoleContextProvider>
          <RouterProvider router={router} />
        </ConsoleContextProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
